import { Box } from '@mui/material'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts'

const PerformanceChart = ({ data }) => {
  return (
    <Box
      sx={{
        width: '100%',
        height: 350,
        mt: 4,
        mb: 4,
        p: 2,
        bgcolor: 'white',
        borderRadius: 2,
        boxShadow: '0px 2px 4px rgba(0,0,0,0.1)'
      }}
    >
      <ResponsiveContainer width='100%' height='90%'>
        <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
          <CartesianGrid strokeDasharray='3 3' vertical={false} />
          <XAxis dataKey='name' />
          <YAxis tickFormatter={(value) => `${value}€`} />
          <Tooltip
            formatter={(value) => [`${value}€`]}
            contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0px 4px 12px rgba(0,0,0,0.15)' }}
          />
          <Legend iconType='circle' verticalAlign='top' height={36} />
          <Bar dataKey='ca' name='CA émis (Facturé)' fill='#1976d2' radius={[4, 4, 0, 0]} />
          <Bar dataKey='treso' name='Trésorerie (Encaissé)' fill='#2e7d32' radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </Box>
  )
}
export default PerformanceChart
